
import "./CraeteUser.css";
import React from "react";
import { ProjectRoleType, radioType } from "../../interfaces";
import { useGlobalContext } from "../../context";
import StarRateIcon from "@mui/icons-material/StarRate";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

function ProjectAndRole() {

    const { projectType, setProjectType } = useGlobalContext();

    const openSelectProjectWindow = (project: ProjectRoleType): void => {
        setProjectType(projectType => projectType.map((type: ProjectRoleType) => type.id === project.id ? { ...type, isOpenProjects:!type.isOpenProjects } : { ...type }));
    }

    const openSelectRoleWindow = (project: ProjectRoleType): void => {
        setProjectType(projectType => projectType.map((type: ProjectRoleType) => type.id === project.id ? { ...type, isOpenRoles: !type.isOpenRoles } : { ...type }));
    }

    const selectProject = ( proj:radioType, projType: ProjectRoleType ): void => {
        setProjectType(projectType => projectType.map((type: ProjectRoleType) => {
            if (type.id === projType.id) {
                return { ...type, projects: type.projects.map(item => item.id === proj.id ? { ...item, active: true } : { ...item, active: false }), isOpenProjects: false };
            }
            else return  { ...type }
        }));
    }

    const selectRole = ( role: radioType, projType: ProjectRoleType ): void => {
        setProjectType(projectType => projectType.map((type: ProjectRoleType) => {
            if (type.id === projType.id) {
                return { ...type, roles: type.roles.map(item => item.id === role.id ? { ...item, active: true } : { ...item, active: false }), isOpenRoles: false };
            }
            else return  { ...type }
        }));
    }

    const findActiveProject = ( projType: ProjectRoleType ): string | undefined => {
        const activeProjType: radioType | undefined = projType.projects.find(item => item.active);
        return activeProjType?.title;
    }

    const findActiveRole = ( projType: ProjectRoleType ): string | undefined => {
        const activeRole: radioType | undefined = projType.roles.find(item => item.active);
        return activeRole?.title;
    }

    const addProjectAndRole = (): void => {
        const lastId: number = projectType[projectType.length - 1].id;
        let projects = [
            {
                id: 1,
                title: "Project X",
                text: "PX",
                active: false
            },
            {
                id: 2,
                title: "Billing Sheet",
                text: "BS",
                active: false
            },
            {
                id: 3,
                title: "Flyer Maker",
                text: "FM",
                active: false
            },
            {
                id: 4,
                title: "Video Maker",
                text: "VM",
                active: false
            },
            {
                id: 5,
                title: "Cover Maker",
                text: "CM",
                active: false
            },
            {
                id: 6,
                title: "QR Code",
                text: "QR",
                active: false
            },
            {
                id:7,
                title: "Linkedin",
                text: "IN",
                active: false
            },
            {
                id: 8,
                title: "Meta Post",
                text: "MP",
                active: false
            },
            {
                id: 9,
                title: "Auto Posting",
                text: "AP",
                active: false
            },
            {
                id: 10,
                title: "Ad Campaign",
                text: "AC",
                active: false
            },
            {
                id: 11,
                title: "Jotform",
                text: "JF",
                active: false
            },
            {
                id: 12,
                title: "Lead Center",
                text: "LC",
                active: false
            },
            {
                id: 13,
                title: "Sales Sheet",
                text: "SS",
                active: false
            },
            {
                id: 14,
                title: "Complaints Sheet",
                text: "CS",
                active: false
            },
            {
                id: 15,
                title: "Timekeeper",
                text: "TK",
                active: false
            },
            {
                id: 16,
                title: "Generic Forms",
                text: "GF",
                active: false
            },
            {
                id: 17,
                title: "SSL Tracker",
                text: "ST",
                active: false
            },
            {
                id: 18,
                title: "Lead Generation Center",
                text: "LCT",
                active: false
            },

            {
                id: 19,
                title: "Voice Campaign",
                text: "VC",
                active: false
            },
            {
                id: 20,
                title: "Commission Hub",
                text: "CH",
                active: false
            },
            {
                id: 21,
                title: "Article Generation",
                text: "AG",
                active: false
            }
        ]

        projectType.forEach(item => {
            const activeProject = item.projects.find(item => item.active);
            if (activeProject) {
                projects = projects.filter(item => item.title !== activeProject.title);
            }
        })

        setProjectType(projectType => {
            return [ ...projectType, {
                id: lastId+1,
                isOpenProjects: false,
                isOpenRoles: false,
                projects: projects,
                roles: [
                    {
                        id: 1,
                        title: "Admin",
                        active: false
                    },
                    {
                        id: 2,
                        title: "Moderator",
                        active: false
                    },
                    {
                        id: 3,
                        title: "User",
                        active: false
                    },
                ]
            }]
        })
    }

    const deleteProjectAndRole = (id: number): void => {
        setProjectType(projectType => projectType.filter(item => item.id !== id));
    }

    const adminForAllProjects = () => {
        const allProjects = projectType[0].projects;
        const newData = [];
        for (let i = 0; i < allProjects.length; i++) {
            const newObj = {
                id: i + 1,
                isOpenProjects: false,
                isOpenRoles: false,
                projects: allProjects.map(item => item.id === allProjects[i].id ? { ...item, active: true } : { ...item, active: false }),
                roles: [
                    {
                        id: 1,
                        title: "Admin",
                        active: true
                    },
                    {
                        id: 2,
                        title: "Moderator",
                        active: false
                    },
                    {
                        id: 3,
                        title: "User",
                        active: false
                    },
                ]
            }
            newData.push(newObj);
        }
        setProjectType(newData);
    }

    return (
        <div className = "PhoneNumbers">
            <div className = 'projectAndRoleSectionAllAdminBox'>
                <button
                    className = 'chooseAllAdminBtn'
                    onClick = { adminForAllProjects }
                >
                   Admin For All
                </button>
            </div>
            <div className = "form-phoneNumber-box add-user-project-info">
                <label
                    className = "required" htmlFor=""
                >
                    Project
                    <StarRateIcon
                        style = {{ color: "red", fontSize: "10px" }}
                    />
                </label>
                <label
                    htmlFor="">
                    Role
                    <StarRateIcon
                        style = {{ color: "red", fontSize: "10px" }}
                    />
                </label>
            </div>
            {
                projectType.map((projType: ProjectRoleType) =>
                <div className = "form-phoneNumber-box mrg-btm" key = { projType.id }>
                    <div className = "phoneNumber-box-dropdown-container add-user-project-info">
                        <div
                            className = "phoneNumber-box-dropdown-header add-user-dropdown-header"
                            onClick = { () => openSelectProjectWindow(projType) }
                        >
                            <span style = {{ margin: "0 auto" }}>{ findActiveProject(projType) }</span>
                            <ArrowDropDownIcon className = "phoneNumber-box-dropdown-header-arrow"/>
                        </div>
                        {
                            projType.isOpenProjects && (
                                <ul className = "phoneNumber-box-dropdown-list">
                                    {
                                        projType.projects.map((proj: radioType) =>
                                            <li
                                                className = "phoneNumber-box-dropdown-li"
                                                onClick = { () => selectProject(proj, projType) }
                                            >
                                                { proj.title }
                                            </li>
                                        )
                                    }
                                </ul>
                            )
                        }
                    </div>
                    <div className="phoneNumber-box-dropdown-container add-user-project-info">
                        <div
                            className = "phoneNumber-box-dropdown-header add-user-dropdown-header"
                            onClick = {() => openSelectRoleWindow(projType)}
                        >
                            <span style = {{ margin: "0 auto" }}>{ findActiveRole(projType) }</span>
                            <ArrowDropDownIcon className = "phoneNumber-box-dropdown-header-arrow"/>
                        </div>
                        {
                            projType.isOpenRoles && (
                                <ul className = "phoneNumber-box-dropdown-list">
                                    {
                                        projType.roles.map((role: radioType) =>
                                            <li
                                                className = "phoneNumber-box-dropdown-li"
                                                onClick = {() => selectRole(role, projType)}
                                            >
                                                { role.title }
                                            </li>
                                        )
                                    }
                                </ul>
                            )
                        }
                    </div>
                    <div className = "phoneNumber-box-delete">
                        {
                            projType.id === 1 ?
                                <div
                                    className = "phoneNumber-box-add"
                                    onClick = { addProjectAndRole }
                                >
                                    <AddIcon
                                        className = "box-addPhone-icon"
                                    />
                                </div>
                                :
                                <DeleteIcon
                                    className = "box-deletePhone-icon"
                                    onClick = { () => deleteProjectAndRole(projType.id) }
                                />
                        }
                    </div>
                </div>
            )}
        </div>
    )
}

export default ProjectAndRole
